import { useCallback, useState } from 'react';
export var useIsScrollBarVisible = function (listRef) {
    var _a = useState(false), isVisible = _a[0], setIsVisible = _a[1];
    var update = useCallback(function () {
        if (listRef.current) {
            var _a = listRef.current, scrollHeight = _a.scrollHeight, clientHeight = _a.clientHeight;
            setIsVisible(scrollHeight > clientHeight);
        }
        else {
            setIsVisible(false);
        }
    }, [listRef.current]);
    return [isVisible, update];
};
//# sourceMappingURL=isScrollBarVisibleHook.js.map